/**
 * Enums do domínio.
 *
 * DUPLICADOS DE PROPÓSITO em relação ao schema Prisma: este pacote é importado
 * pelo navegador e NÃO PODE depender de `@prisma/client` (arrastaria o engine
 * do Prisma para o bundle). Os nomes e valores têm de bater exatamente com
 * `packages/db/prisma/schema.prisma` — se mudar lá, mude aqui.
 */
export const CONDICOES = ['NOVA', 'USADA'];
/**
 * A ORDEM importa e espelha a do enum no Postgres: `orderBy: { status: 'asc' }`
 * ordena por ela, jogando as vendidas para o fim da vitrine.
 */
export const STATUS_PRODUTO = ['RASCUNHO', 'DISPONIVEL', 'RESERVADA', 'VENDIDA'];
/** Status que o público pode ver. RASCUNHO nunca sai em rota pública. */
export const STATUS_PUBLICOS = ['DISPONIVEL', 'RESERVADA', 'VENDIDA'];
/** Status em que a bike ainda pode ser negociada (botão de WhatsApp ativo). */
export const STATUS_NEGOCIAVEIS = ['DISPONIVEL', 'RESERVADA'];
export const ORDENACOES = [
    'destaque',
    'recentes',
    'preco_asc',
    'preco_desc',
    'nome_asc',
];
export const DISPONIBILIDADES = ['todas', 'disponiveis'];
/** Categorias sugeridas. Campo é texto livre — isto alimenta o autocomplete. */
export const CATEGORIAS_SUGERIDAS = [
    'mtb',
    'urbana',
    'speed',
    'infantil',
    'bmx',
    'eletrica',
];
export const GRUPOS_CONFIGURACAO = ['contato', 'vitrine', 'seo'];
export function ehStatusPublico(status) {
    return STATUS_PUBLICOS.includes(status);
}
export function ehNegociavel(status) {
    return STATUS_NEGOCIAVEIS.includes(status);
}
//# sourceMappingURL=enums.js.map